export const EditOrderEvents = {
  CollapseCarrierAndPermitDelivery:
    'editOrder.collapseCarrierAndPermitDelivery',
  UncollapseCarrierAndPermitDelivery:
    'editOrder.uncollapseCarrierAndPermitDelivery',
  CollapseLoadInformation: 'editOrder.collapseLoadInformation',
  UncollapseLoadInformation: 'editOrder.uncollapseLoadInformation',
  CollapseHaulingEquipment: 'editOrder.collapseHaulingEquipment',
  UncollapseHaulingEquipment: 'editOrder.uncollapseHaulingEquipment',
  CollapseAxleConfiguration: 'editOrder.collapseAxleConfiguration',
  UncollapseAxleConfiguration: 'editOrder.uncollapseAxleConfiguration',
  CollapseRoutingAndStates: 'editOrder.collapseRoutingAndStates',
  UncollapseRoutingAndStates: 'editOrder.uncollapseRoutingAndStates',
  CollapseAccountsAndInsurances: 'editOrder.collapseAccountsAndInsurances',
  UncollapseAccountsAndInsurances: 'editOrder.uncollapseAccountsAndInsurances',
  CollapseNotesAndDocuments: 'editOrder.collapseNotesAndDocuments',
  UncollapseNotesAndDocuments: 'editOrder.collapseNotesAndDocuments',
};

export const editOrderCarrierAndPermitDeliveryEvents = {
  collapseEventName: EditOrderEvents.CollapseCarrierAndPermitDelivery,
  uncollapseEventName: EditOrderEvents.UncollapseCarrierAndPermitDelivery,
};
export const editOrderLoadInformationEvents = {
  collapseEventName: EditOrderEvents.CollapseLoadInformation,
  uncollapseEventName: EditOrderEvents.UncollapseLoadInformation,
};
export const editOrderHaulingEquipmentEvents = {
  collapseEventName: EditOrderEvents.CollapseHaulingEquipment,
  uncollapseEventName: EditOrderEvents.UncollapseHaulingEquipment,
};
export const editOrderAxleConfigurationEvents = {
  collapseEventName: EditOrderEvents.CollapseAxleConfiguration,
  uncollapseEventName: EditOrderEvents.UncollapseAxleConfiguration,
};
export const editOrderRoutingAndStatesEvents = {
  collapseEventName: EditOrderEvents.CollapseRoutingAndStates,
  uncollapseEventName: EditOrderEvents.UncollapseRoutingAndStates,
};
export const editOrderAccountsAndInsurancesEvents = {
  collapseEventName: EditOrderEvents.CollapseAccountsAndInsurances,
  uncollapseEventName: EditOrderEvents.UncollapseAccountsAndInsurances,
};
export const editOrderNotesAndDocumentsEvents = {
  collapseEventName: EditOrderEvents.CollapseNotesAndDocuments,
  uncollapseEventName: EditOrderEvents.UncollapseNotesAndDocuments,
};
